import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import "./CustomPaymentComponent.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import CircularProgress from "@material-ui/core/CircularProgress";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function sendPdfToBackend(invoiceBlob, bindBlob, prospectID, bindData) {
  const formData = new FormData();
  formData.append("invoicePdf", invoiceBlob, "invoice.pdf");
  formData.append("bindPdf", bindBlob, "bind.pdf");
  formData.append("bindData", JSON.stringify(bindData));

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/pdf/customBind`,
      {
        method: "POST",
        body: formData,
        headers: {
          // Assuming prospectId is still needed as a header
          prospectId: prospectID,
        },
      }
    );

    if (response.ok) {
      const responseData = await response.json();
      console.log("PDFs uploaded successfully:", responseData);
    } else {
      throw new Error("Failed to upload PDFs");
    }
  } catch (error) {
    console.error("Error sending PDFs:", error);
  }
}
function formatPolicyNumber(policyNumber) {
  // Convert policy number to string and pad it with zeros to ensure it is at least 3 digits
  const paddedNumber = policyNumber.toString().padStart(3, "0");
  // Prepend the prefix "CLEIQ"
  const formattedPolicyNumber = `CLEIQ${paddedNumber}`;
  return formattedPolicyNumber;
}

async function fetchPolicyNumber() {
  try {
    const policyNumberResponse = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/pdf/newPolicyNumber`,
      { method: "GET" }
    );
    if (!policyNumberResponse.ok) {
      throw new Error(
        "Failed to fetch policy number: " + policyNumberResponse.statusText
      );
    }
    const data = await policyNumberResponse.json();
    return data.policyNumber; // Assuming the response JSON contains a key `policyNumber`
  } catch (error) {
    console.error("Error fetching policy number:", error);
    // Handle errors appropriately, perhaps set an error state
  }
}

export async function generateInvoicePdf(
  premium = 0,
  customerName,
  effectiveDate,
  expiryDate,
  prospectDetails,
  insurerId,
  body,
  insurerFees,
  brokerInformation
) {
  const coverage = [
    "24/7 Legal Advice Service",
    "Debt Recovery",
    "Contract Dispute",
    "Employment Disputes",
    "Employment Restrictive Covenants",
    "Legal Defence",
    "Property Disputes",
    "Personal Injury",
    "Tax Disputes",
    "Statutory License Protections",
  ];
  const today = new Date();
  const currentDate = today.toISOString().split("T")[0]; // Formats the date as "YYYY-MM-DD"
  // eslint-disable-next-line no-extra-parens

  const commisionPercentage = 0.15;
  const commison = premium * commisionPercentage;
  const premiumMinusCommison = premium - commison;
  const fee = insurerFees;
  const total = premiumMinusCommison + fee;
  var lloydsBase64Image = "";
  var approvedCasualtyLegalBase64 = "";
  const response = await fetch(
    process.env.REACT_APP_BASICSERVICE +
      "/api/prospects/getCustomBindPaymentInformation",
    {
      method: "POST", // Specify the method
      headers: {
        "Content-Type": "application/json", // Set the headers to inform server about the data type
      },
      body: JSON.stringify({
        prospectId: prospectDetails.prospectid, // ES6 shorthand for prospectId: prospectId
        insurerId: insurerId, // ES6 shorthand for insurerId: insurerId
      }),
    }
  );

  const policyNumber = await fetchPolicyNumber();
  console.log("show me policy number", policyNumber);

  const bindData = await response.json();

  await fetch("/largeImageBase64.txt")
    .then((response) => response.text())
    .then((data) => {
      // Update state with the loaded base64 string

      lloydsBase64Image = data;
    });
  await fetch("/approvedCasualtyBase64.txt")
    .then((response) => response.text())
    .then((data) => {
      // Update state with the loaded base64 string

      approvedCasualtyLegalBase64 = data;
    });

  const ddBind = {
    content: [
      {
        // Stack for header and border
        stack: [
          {
            // Canvas for the border
            canvas: [
              {
                type: "rect",
                x: 0,
                y: -5,
                w: 515, // Width of the border - adjust as needed
                h: 75, // Height of the border - adjust as needed
                lineWidth: 1,
                lineColor: "black",
              },
            ],
            // Absolute position is required to place canvas behind the columns
            absolutePosition: { x: 40, y: 60 }, // Adjust position as needed
          },
          {
            // Header Columns
            columns: [
              {
                // Lloyds Logo Placeholder
                image: "data:image/png;base64," + lloydsBase64Image,
                width: 100,
                margin: [0, 10, 2, 0],
              },
              {
                // Insurance Details
                stack: [
                  {
                    text: "COMMERCIAL LEGAL EXPENSE INSURANCE",
                    bold: false,
                    fontSize: 10,
                  },
                  {
                    text: "Covered with certain Lloyd's Underwriters through Lloyd's Approved",
                    fontSize: 10,
                  },
                  {
                    text: "Coverholder (“the Coverholder”):",
                    fontSize: 10,
                  },
                  {
                    text: "Approved Casualty and Surety Inc.",
                    fontSize: 10,
                  },
                  {
                    text: "1275 North Service Road W, Suite 605, Oakville, ON L6M 2W2",
                    fontSize: 10,
                  },
                ],
                fontSize: 12,
                margin: [40, 10, 0, 0],
              },
            ],
            // Relative position to move the columns inside the border
            relativePosition: { x: 40, y: 15 }, // Adjust position as needed
          },
        ],
        // Required to prevent other content from overlapping with the header
        margin: [0, 0, 0, 50], // Bottom margin to push content below the header
      },

      {
        // Policy Notice
        text: "THIS POLICY CONTAINS A CLAUSE WHICH MAY LIMIT THE AMOUNT PAYABLE.",
        bold: true,
        fontSize: 18,
        alignment: "center",
        margin: [10, 80, 5, 5],
      },
      {
        // Policy Notice
        text: "DECLARATIONS",
        bold: true,
        fontSize: 13,
        alignment: "center",
        margin: [0, 30, 0, 15],
      },
      {
        // Declarations
        stack: [
          {
            text: "POLICY NO: " + formatPolicyNumber(policyNumber),
            alignment: "right",
            fontSize: 12,
            margin: [0, 0, 0, 10],
            bold: true,
          },
          {
            // When you want to combine text and styles, make sure each part is correctly structured
            text: [
              {
                text: "INSURED NAME: ",
                bold: true,
                fontSize: 12,
                margin: [0, 4, 0, 0],
              },
              {
                text: customerName,
                bold: false,
                fontSize: 12,
                margin: [0, 4, 0, 0],
              },
            ],
          },
          {
            text: [
              {
                text: "INSURED ADDRESS: ",
                bold: true,
                fontSize: 12,
                margin: [0, 4, 0, 0],
              },
              {
                text:
                  prospectDetails.CLIENT_ADDRESS.street1 +
                  "," +
                  prospectDetails.CLIENT_ADDRESS.town +
                  "," +
                  prospectDetails.CLIENT_ADDRESS.postalcode +
                  "," +
                  prospectDetails.CLIENT_ADDRESS.province,
                bold: false,
                fontSize: 12,
                margin: [0, 4, 0, 0],
              },
            ],
            margin: [0, 4, 0, 0],
          },
          {
            text: "PERIOD OF INSURANCE:",
            fontSize: 12,
            margin: [0, 4, 0, 0],
            bold: true,
          },
          {
            text: [
              { text: "from: ", bold: true, fontSize: 12 },
              { text: effectiveDate, bold: false, fontSize: 12 },
            ],
            margin: [103, 4, 0, 0],
          },
          {
            text: [
              { text: "to: ", bold: true, fontSize: 12 },
              { text: expiryDate, bold: false, fontSize: 12 },
            ],
            margin: [119, 4, 0, 10],
          },
          {
            text: [
              {
                text: "(both days at 12:01 a.m. Standard Time at the Address of the Insured).",

                fontSize: 10,
              },
            ],
            margin: [128, 0, 0, 10],
          },

          {
            text: [
              { text: "PREMIUM: ", bold: true, fontSize: 12 },
              {
                text: "$" + premium.toString(),
                bold: false,
                fontSize: 12,
                margin: [20, 0, 0, 20],
              },
            ],
          },

          {
            table: {
              headerRows: 1,
              widths: ["*", "auto"], // First column fills remaining space, second is as wide as its content

              body: [
                // Header row
                [
                  { text: "Limit of Liability", style: "tableHeader" },
                  { text: "Amount", style: "tableHeader" },
                ],
                // Data rows
                ["Any One Claim", "$50,000"],
                ["Aggregate Limit", "$100,000"],
                ["Deductible (Standard)", "$500"],
                [
                  "Deductible (Contractor/Construction Industry Insureds)",
                  "$2,500",
                ],
                ["Deductible for Legal Advice Service", "N/A"],
              ],
            },
            layout: "lightHorizontalLines", // This adds horizontal lines between rows
            margin: [0, 5, 0, 20], // Margins for the entire table
            style: "tableStyle",
          },
          {
            text: "POLICY COVERAGE:",
            fontSize: 14,
            margin: [0, 0, 0, 10],
            bold: true,
          },
          {
            ul: coverage.map((cover) => ({
              text: cover,
              fontSize: 11,
            })),
            margin: [20, 0, 0, 20],
          },
          {
            text: "The insurance contract consists of this Declarations page as well as all coverage wordings, riders, or endorsements that are attached hereto.",
            margin: [0, 10, 0, 0],
            fontSize: 12,
          },
        ],
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
      },
      subheader: {
        fontSize: 15,
        bold: true,
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        margin: [0, 5, 0, 5], // Top, Right, Bottom, Left
        alignment: "left",
      },
      tableStyle: {
        margin: [0, 5, 0, 15],
      },
    },
  };

  const ddInvoice = {
    pageSize: {
      width: 612.72, // 8.51 inches in points
      height: 841.68, // 11.69 inches in points
    },
    content: [
      //   {
      //     image: "data:image/png;base64," + lloydsBase64Image,
      //     width: 150,
      //     alignment: "center",
      //     margin: [0, 0, 0, 10],
      //   },
      {
        //first set of col
        columns: [
          {
            image: "data:image/png;base64," + approvedCasualtyLegalBase64,
            width: 100,
            alignment: "left",
            margin: [0, 0, 0, 30],
          },
          {
            // Column 1 for company information

            text: "Approved Casualty and Surety Inc.\n",
            fontSize: 8,
            alignment: "right",
            margin: [0, 0, 10, 30],
          },
        ],
      },
      {
        //second set of col
        columns: [
          {
            // Column 1 for company information
            width: "50%",
            text: `${brokerInformation.brokerages[0].name}\n ${
              brokerInformation.location
                ? brokerInformation.location
                : brokerInformation.brokerages[0].address[0].city
            }`,
            fontSize: 10,
            alignment: "left",
            margin: [0, 0, 0, 10],
          },
          {
            // Column 2 for policy details
            width: "50%",
            stack: [
              {
                columns: [
                  { text: "Date ", fontSize: 10, bold: true, width: "auto" },
                  {
                    text: currentDate,
                    fontSize: 10,
                    bold: false,
                    margin: [10, 0, 0, 0],
                  },
                ],
                margin: [0, 0, 0, 10],
              },
              {
                columns: [
                  {
                    text: "Customer Name ",
                    fontSize: 10,
                    bold: true,
                    width: "auto",
                  },
                  {
                    text: customerName,
                    fontSize: 10,
                    bold: false,
                    margin: [10, 0, 0, 0],
                  },
                ],
                margin: [0, 0, 0, 18],
              },
              {
                columns: [
                  {
                    text: "Policy Number ",
                    fontSize: 10,
                    bold: true,
                    width: "auto",
                  },
                  {
                    text: formatPolicyNumber(policyNumber),
                    fontSize: 10,
                    bold: false,
                    margin: [10, 0, 0, 0],
                  },
                ],
                margin: [0, 0, 0, 10],
              },
              {
                columns: [
                  {
                    text: "Effective Date ",
                    fontSize: 10,
                    bold: true,
                    width: "auto",
                  },
                  {
                    text: effectiveDate,
                    fontSize: 10,
                    bold: false,
                    margin: [10, 0, 0, 0],
                  },
                ],
                margin: [0, 0, 0, 10],
              },
              {
                columns: [
                  {
                    text: "Expiry Date ",
                    fontSize: 10,
                    bold: true,
                    width: "auto",
                  },
                  {
                    text: expiryDate,
                    fontSize: 10,
                    bold: false,
                    margin: [10, 0, 0, 0],
                  },
                ],
              },
            ],
            alignment: "right",
            margin: [0, 0, 100, 10],
          },
        ],
      },
      {
        text: "---------- INVOICE ----------",
        alignment: "center",
        bold: true,
        fontSize: 15,
        margin: [0, 40, 0, 10],
      },
      {
        style: "tableExample",
        table: {
          widths: [50, 150, 100, 90, 90],
          body: [
            [
              { text: "Trans\nCode", style: "tableHeader", rowSpan: 2 },
              { text: "Description", style: "tableHeader", rowSpan: 2 },
              { text: "Premium", style: "tableHeader", rowSpan: 2 },
              { text: "Commissions", style: "tableHeader", rowSpan: 2 },
              {
                text: "Net\nPremium",
                style: "tableHeaderLeftAligned",
                rowSpan: 2,
              },
            ],
            [""], // This empty row is necessary due to rowSpan
            [
              { text: "NEW", style: "tableBody" },
              {
                text: "Commercial Legal Expense\nInsurance Coverage",
                style: "tableBody",
              },
              { text: "$" + premium.toFixed(2), style: "tableBody" },
              { text: "15%", style: "tableBody" },
              {
                text: "$" + premiumMinusCommison.toFixed(2),
                style: "tableTotal",
                fontSize: 10,
              },
            ],
            [
              { text: "NEW", style: "tableBody" },
              { text: "Policy Fee", style: "tableBody" },
              { text: "$" + insurerFees.toFixed(2), style: "tableBody" },
              { text: "0%", style: "tableBody" },
              {
                text: "$" + insurerFees.toFixed(2),
                style: "tableTotal",
                fontSize: 10,
              },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "", style: "tableBody", bold: true },
              { text: "", style: "tableBody", bold: true },
            ],
            [
              { text: "", style: "tableBody" },
              { text: "", style: "tableBody", colSpan: 2 },
              "",
              { text: "*Net Due:", style: "tableBodyNet", bold: true },
              {
                text: "$" + total.toFixed(2),
                style: "tableTotal",
                bold: true,
                fontSize: 12,
              },
            ],
            [
              { text: "", colSpan: 1, style: "tableHeader" },
              {
                text: "* Premium Due and Payable Within 30 Days of Effective Date",
                style: "tableHeader",
                colSpan: 3,
                alignment: "center",
                fontSize: 9,
              },
              "",
              "",
              { text: "", style: "tableHeader" },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 1 || i === 0 || i === node.table.body.length) {
              // Check for first and last row
              return 1; // Apply a line width of 1 for the top and bottom borders
            }
            return 0; // No horizontal lines for other rows
          },
          vLineWidth: function (i, node) {
            if (i === 1 || i === 4) {
              return 1; // Keep vertical lines between specified columns
            }
            return 0; // No vertical lines elsewhere
          },
          hLineColor: function (i, node) {
            return "gray"; // Color for horizontal lines
          },
          vLineColor: function (i, node) {
            return "gray"; // Color for vertical lines
          },
        },
      },

      {
        text: "Please Send Payment to:",
        alignment: "left",
        fontSize: 10,
        margin: [180, 20, 0, 0], // Adds space above this line
      },
      {
        text: "Approved Casualty & Surety Inc.\n 1275 North Service Road W, Suite 605\nOakville, ON L6M 2W2",
        alignment: "left",
        fontSize: 13,
        margin: [180, 15, 0, 40], // Adds a small space above and larger space below
        italics: true,
      },
    ],
    styles: {
      tableExample: {
        margin: [0, 5, 0, 15],
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: "black",
        alignment: "center",
        fillColor: "#dddddd",
        margin: [0, 5, 0, 5],
      },
      tableHeaderLeftAligned: {
        bold: true,
        fontSize: 10,
        color: "black",
        alignment: "left",
        fillColor: "#dddddd",
        margin: [0, 5, 0, 5],
      },
      tableBody: {
        fontSize: 10,
        color: "black",
        alignment: "center",
        margin: [0, 5, 0, 5],
      },
      tableBodyNet: {
        fontSize: 12,
        color: "black",
        alignment: "right",

        margin: [0, 5, 0, 5],
      },
      tableTotal: {
        color: "black",
        alignment: "left",
        margin: [0, 5, 0, 5],
      },
    },
  };

  // pdfMake.createPdf(ddInvoice).download("my_document_invoice.pdf");
  // pdfMake.createPdf(ddBind).download("my_document_bind.pdf");

  const pdfDocGeneratorInvoice = pdfMake.createPdf(ddInvoice);
  const pdfDocGeneratorBind = pdfMake.createPdf(ddBind);

  const invoiceBlob = await new Promise((resolve) =>
    pdfDocGeneratorInvoice.getBlob(resolve)
  );
  const bindBlob = await new Promise((resolve) =>
    pdfDocGeneratorBind.getBlob(resolve)
  );
  body.otherData.bindernumber = formatPolicyNumber(policyNumber);

  // Proceed to send these blobs to the backend
  return await sendPdfToBackend(
    invoiceBlob,
    bindBlob,
    prospectDetails.prospectid,
    body
  );
}
